import { createContext } from 'react';
import { RecaptchaRef } from 'components/Recaptcha';

type PremiumBuyerSubscriptionProps = {
  recaptchaRef: React.RefObject<RecaptchaRef>;
};

export default createContext<Partial<PremiumBuyerSubscriptionProps>>({
  recaptchaRef: null,
});
